import { getUrl } from '@/lib/device-utils';
import { getOpenAlexId } from '@/lib/reference-identifiers';

type ReferenceDetailLike = {
  doc_id?: string | null;
  link?: string | null;
  pmid?: string | null;
  openalex_id?: string | null;
  search_gateway?: string | null;
};

function buildDetailUrl(source: string, did: string, platform: string) {
  const docId = `${source}|${did}`;
  return getUrl(docId, platform);
}

export function getReferenceDetailUrl(
  reference: ReferenceDetailLike,
  platform = 'desktop',
) {
  const docId = reference.doc_id?.trim();
  if (docId) {
    const [source, did] = docId.split('|');
    if (source && did) {
      return getUrl(docId, platform);
    }
  }

  const gateway = reference.search_gateway?.trim().toLowerCase();
  const openAlexId = getOpenAlexId(reference);
  if (gateway === 'openalex' || openAlexId) {
    return openAlexId ? buildDetailUrl('openalex', openAlexId, platform) : '';
  }

  const pmid = reference.pmid?.trim();
  if (pmid && gateway !== 'openalex') {
    return buildDetailUrl('pubmed', pmid, platform);
  }

  return '';
}
